export default "__VITE_ASSET__D293Rbcp__"